<template>
  <v-tooltip
    :right="!isMobile"
    max-width="300px"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        outlined
        :loading="loading"
        fab
        small
        class="border d-flex align-items-center justify-center"
        :class="{
          'border-white bg-inDarkActive' : $store.state.module.view_dark,
          'border-nitro' : !$store.state.module.view_dark,
          'bg-transparent' : !content.liked,
          'bg-colored' : content.liked == actionValue && !$store.state.module.view_dark,
          'bg-white' : content.liked == actionValue && $store.state.module.view_dark,
        }"
        v-bind="attrs"
        :style="`${actionValue == 'negative' ? 'transform: rotate(180deg)': ''}`"
        v-on="on"
        @click="rate_content(content)"
      >
        <img
          :src="`/images/icon_like_${icon_color}.png`"
          width="25px"
        >
      </v-btn>
    </template>
    <span>{{ actionValue == 'positive' ? 'Adorei o conteúdo' : 'O conteúdo não me ajudou' }}</span>
  </v-tooltip>
</template>
<script>
 import { mapActions, mapMutations, mapGetters } from 'vuex'
 import ActiveTabMixin from './ActiveTabMixin'
 import {  rateContent } from '@/student/api/Content.js'


 export default {
   mixins: [ActiveTabMixin],
    props:{
      actionValue: {
        type: String,
        required: false,
        default: 'positive',
        validator(value) {
          return ['positive', 'negative'].includes(value)
        }
    }
  },
  data(){
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['module', 'content', 'completed_contents', 'cycles', 'selectedCycle']),
    icon_color() {
        if (this.$store.state.module.view_dark ) {
          return this.content.liked === this.actionValue ? 'black' :  'white';
        } 
        return this.content.liked === this.actionValue ? 'white' : 'color'
      }, 
    },
    isFocusedInDark() {
      return this.$el === document.activeElement && this.$store.state.module.view_dark;
    },
    methods: {
      ...mapMutations(['SET_MODULE','SET_CYCLES','SET_CYCLE','SET_MODULE_CONTENTS']),
      ...mapActions(['load']),
      rate_content(content) {
          
          this.loading = true
  
          this.SET_MODULE_CONTENTS(this.module.contents.map(c => ({
            ...c,
            liked: c.id == content.id ? null : c.liked
          })))

          rateContent(content.id, {like: content.liked == this.actionValue ? 'undo' : this.actionValue })
          .then(({data: {data: module}}) => {
            
            this.SET_MODULE_CONTENTS(module.contents)

            this.$notify({ type: 'success', text: 'Obrigado por avaliar este conteúdo.'})
  
          })
          .finally(() => {
            this.loading = false;
          })
      },
      
    }
  }
</script>
<style lang="css" scoped>
.bg-colored {
  background-color: #060181 !important;
}
.bg-inDarkActive:active {
  background-color: rgba(6, 1, 129, 0.3) !important;
}
</style>